import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type {
  JsonObject,
  GetDateFilteredVirtualToursByListingParams,
  GetDateFilteredVirtualToursByListingResponse,
} from '@/app-package';

/**
 * Retrieves virtual tours filtered by date for a specific listing, user, or team
 * @param dateFrom - Optional start date filter
 * @param dateTo - Optional end date filter
 * @param type - Type of model to filter by (listing, user, or team)
 * @param modelId - ID of the model to filter by
 */
const getDateFilteredVirtualTours = async ({
  dateFrom,
  dateTo,
  type,
  modelId,
}: GetDateFilteredVirtualToursByListingParams) => {
  const config: AxiosRequestConfig = {
    url: `/virtual_tour/date/${type}/${modelId}`,
    method: 'get',
    params: { dateFrom, dateTo },
  };

  const { data } =
    await axios.request<
      JsonObject<GetDateFilteredVirtualToursByListingResponse>
    >(config);

  return data;
};

export default getDateFilteredVirtualTours;
